import React from "react";
import Icons from "../../../../config/images";
import "./VisionMission.css";
const VisionMission = () => {
  return (
    <>
      <div className="vision-mission-section">
        <div className="vision-mission-content">
          <h2>Our Vision & Mission</h2>
          <p className="p1">
            Our vision is to digitally transform the jewellery industry by
            building intelligent, reliable, and scalable technology solutions
            that simplify complex business operations. We aim to create a future
            where jewellery businesses of all sizes can leverage data,
            automation, and innovation to operate more efficiently, make
            informed decisions, and achieve sustainable long-term growth.
          </p>

          <p className="p2">
            Our mission is to empower jewellery businesses with custom-built web
            and mobile applications designed around real-world workflows. By
            delivering secure, high-performance, and user-friendly solutions, we
            help brands, retailers, wholesalers, and manufacturers streamline
            operations, improve efficiency, and confidently adapt, scale, and
            succeed in an ever-evolving digital ecosystem.
          </p>
        </div>
        <div className="vision-mission-img">
          <img src={Icons.mission_vision_img} alt="" />
        </div>
      </div>
    </>
  );
};

export default VisionMission;
